import React from 'react';
function getEmptyHeader({ headerClassName, }){
  const classNames = `${ headerClassName } ${ headerClassName }--empty`;
  return (
    <header
      className={ classNames }
    />
  );
}
function getHeader({ headerClassName, blockName, headerText, headerImage, }){
  return (
    <header
      className={ headerClassName }
    >
      <span className={ `${ blockName }__header-text` }>
        { headerText }
      </span>
      <img
        className={ `${ blockName }__header-image` }
        src= { headerImage }
      />
    </header>
  );
}
export default function ReactionHeader({ blockName, headerText, headerImage, }){
  const headerClassName = `${ blockName }__header-container`;
  if (!headerText || !headerImage) {
    return getEmptyHeader({ headerClassName });
  }
  return getHeader({ headerClassName, blockName, headerText, headerImage });
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/reactions/components/reactionHeader.js